import { useEffect, useState } from "react"
import {
  Calendar,
  User,
  Building2,
  Package,
  Microscope
} from "lucide-react"

import { QuickAccessCard } from "../quick-access-card"

export default function QuickAccessTileswidget() {

  const [items, setItems] = useState([])

  useEffect(() => {
    fetch("/wp-json/custom/v1/quick-access")
      .then(res => res.json())
      .then(data => setItems(data))
      .catch(() => setItems([]))
  }, [])

  const getIcon = (icon) => {
    switch (icon) {
      case "calendar":
        return <Calendar className="w-6 h-6 text-primary" />
      case "user":
        return <User className="w-6 h-6 text-primary" />
      case "building":
        return <Building2 className="w-6 h-6 text-primary" />
      case "package":
        return <Package className="w-6 h-6 text-primary" />
      case "microscope":
        return <Microscope className="w-6 h-6 text-primary" />
      default:
        return <Calendar className="w-6 h-6 text-primary" />
    }
  }

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5">

          {items.map((item, index) => (
            <QuickAccessCard
              key={index}
              icon={getIcon(item.icon)}
              title={item.title}
              href={item.link}
            />
          ))}

        </div>
      </div>
    </section>
  )
}